const CONTENT_FIELDS = ["headline", "subheadline", "excerpt", "body", "the_dish", "hero_caption", "tags", "key_takeaways", "social_summary", "seo_title", "meta_description", "hero_alt"];
const populated = (value) => value != null && value !== "" && (!Array.isArray(value) || value.length > 0);
function covers(original, translated) {
  if (!populated(original)) return true;
  if (typeof original === "string") return typeof translated === "string" && translated.trim().length > 0;
  if (Array.isArray(original)) return Array.isArray(translated) && translated.length === original.length && original.every((v, i) => covers(v, translated[i]));
  if (typeof original === "object") return translated && typeof translated === "object" && Object.keys(original).every(key => key === "type" ? original[key] === translated[key] : covers(original[key], translated[key]));
  return typeof original === typeof translated;
}
export function articleLanguage(article, requested = "en") {
  const id = article?.translations?.id;
  if (!article || article.translation_available === false || (id?._meta && id._meta.status !== "complete") || requested !== "id" || !id || (typeof id.headline !== "string" || !id.headline.trim()) || !Array.isArray(id.body) || !id.body.length ||
      !CONTENT_FIELDS.every(key => covers(article[key], id[key]))) return { article, language: "en" };
  // Never inherit English editorial or SEO strings into a translated article.
  const localized = { ...article, seo_title: id.seo_title, meta_description: id.meta_description };
  CONTENT_FIELDS.forEach(key => { localized[key] = id[key]; });
  return { article: localized, language: "id" };
}
export function hasIndonesianTranslation(article) { return articleLanguage(article, "id").language === "id"; }
export function articlePath(article, language = "en") {
  return `${language === "id" ? "/id" : ""}/${encodeURIComponent(article.category)}/${encodeURIComponent(article.slug)}`;
}
export function publicSiteOrigin() {
  return document.head.querySelector('meta[name="td-site-origin"]')?.content || process.env.REACT_APP_PUBLIC_SITE_URL || window.location.origin;
}
export function canonicalArticleUrl(article, origin = publicSiteOrigin(), language = "en") {
  return origin + articlePath(article, language);
}
